<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path stroke="currentColor" d="m0 6 6-6 6 6" style="fill:none;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.4px" transform="rotate(90 4.5 6.5)" fill="currentColor"/></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-arrow-right',
});
</script>
